export const stepOneData = [
  {
    heading: "Why Use the SBI Home Loan EMI Calculator?",
    // paras before heading

    impactHead: "Impact of Loan Tenure on EMI and Total Repayment",

    infoList: [
      {
        heading: "Accurate EMI Calculations: ",
        description:
          "Get precise estimates for your monthly payments, including both principal and interest components.",
      },
      {
        heading: "Simple to Use: ",
        description:
          "This tool is user-friendly and available for free on the SBI website.",
      },
      {
        heading: "Detailed Breakdown: ",
        description:
          "View your EMI breakdown in terms of principal and interest.",
      },
      {
        heading: "Convenient Access: ",
        description:
          "Available online 24/7, making it easy to calculate your EMI whenever you need it.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "SBI Home Loan EMI Calculator Features",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Maximum Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Home Loan",
          interest: "8.70% p.a.",
          tenure: "Up to 30 years",
          fee: "₹10,000 to ₹15,000",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Benefits of Using the SBI Home Loan EMI Calculator",

    factorsList: [
      {
        heading: "Financial Planning: ",
        info: "Knowing your EMIs upfront helps you manage your budget and make informed decisions.",
      },
      {
        heading: "Comparison of Loan Offers: ",
        info: "Easily compare different loan amounts, tenures, and interest rates to find the best offer.",
      },
      {
        heading: "Transparent Calculation: ",
        info: "The calculator provides a detailed EMI schedule and highlights the principal and interest portions.",
      },
      {
        heading: "Free Access: ",
        info: "The calculator is free and easy to use, providing instant results.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "Factors Influencing Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "The higher the loan amount, the higher the EMI.",
      },
      {
        heading: "Interest Rate: ",
        info: "A higher interest rate increases the EMI and the total repayment amount.",
      },
      {
        heading: "Loan Tenure: ",
        info: "Longer tenures result in lower EMIs but increase the total interest paid over the life of the loan.",
      },
      {
        heading: "Processing Fees: ",
        info: "SBI charges a processing fee that can affect the overall cost of your loan.",
      },
      {
        heading: "Prepayment and Foreclosure: ",
        info: "Prepaying part of your loan can reduce the principal amount, lowering both the EMI and total repayment.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "How to Use the SBI Home Loan EMI Calculator",
  },
];
export const stepSixData = [
  {
    heading: "Impact of Loan Tenure on EMI and Total Repayment",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher	",
          interest: "Lower",
          repayment: "Lower",
        },
        {
          tenure: "10 years	",
          emi: "Moderate",
          interest: "Moderate",
          repayment: "Moderate",
        },
        {
          tenure: "15 years",
          emi: "Lower	",
          interest: "Higher",
          repayment: "Higher",
        },
      ],
    },
  },
];
export const stepSevenData = [
  {
    heading: "MinEmi Tips for Borrowing from SBI",
    infoList: [
      {
        head: "Negotiate the Interest Rate: ",
        info: "If you have a strong credit score (750+), consider negotiating for a lower rate.",
      },
      {
        head: "Check for Processing Fee Discounts: ",
        info: "Look out for special offers that reduce or waive processing fees.",
      },
      {
        head: "Prepayment Option: ",
        info: "If you have extra funds, consider making partial prepayments to reduce your principal and save on interest.",
      },
      {
        head: "Maintain a Good Credit Score: ",
        info: "A high credit score enhances your chances of securing a lower rate.",
      },
    ],
  },
];
